import { atom, atomFamily, selector, selectorFamily, useRecoilState } from "recoil";
import produce from "immer";
import moment from "moment";
import findIndex from "lodash/findIndex"
import map from "lodash/map"
import reverse from "lodash/reverse"
import { getGameTemplate, getGameTemplates, updateGameTemplate } from "api/GameTemplatesApi.js";

const loadGameTemplateList = selector({
    key: "LoadGameTemplateList",
    get: async () => {
        const response = await getGameTemplates();
        return reverse(map(response.body, template => ({
            ...template,
            startDateMoment: template.startDate ? moment(template.startDate) : null,
        })));
    },
});

export const gameTemplateListState = atom({
    key: "GameTemplateListState",
    default: loadGameTemplateList,
});

const loadGameTemplateDetails = selectorFamily({
    key: "LoadGameTemplateDetails",
    get: (templateId) => async () => {
        const response = await getGameTemplate(templateId);
        return response.body;
    },
});

export const gameTemplateDetailsState = atomFamily({
    key: "GameTemplateDetailsState",
    default: loadGameTemplateDetails,
});

export function useGameTemplateListStateMutations() {
    const [gameTemplatesList, setGameTemplatesList] = useRecoilState(gameTemplateListState);

    const updateGameTemplateFromList = async (template) => {
        const response = await updateGameTemplate(template);
        setGameTemplatesList(produce(gameTemplatesList, draft => {
            const templateIndex = findIndex(gameTemplatesList, { greenlineGameTemplateId: template.greenlineGameTemplateId });
            draft[templateIndex] = response.body;
        }));
    };

    return {
        updateGameTemplateFromList,
    };
}
